export default __webpack_public_path__ + "static/media/ReportIcon-OxygenTank-MS.684eeaf7.jpg";